enum PrimaryButtonSize {
    Regular = "regular",
    Small = "small"
}

export default PrimaryButtonSize;
